import * as React from 'react'
import { IconChevronRight, IconChevronLeft } from '../../Icons'
import PropTypes from 'prop-types'

export const BlogSliderButtonPrev = ({ onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      className={
        'absolute top-[calc(50%-3rem)] left-0 h-24 w-12 bg-gray-300 bg-opacity-50 duration-300 hover:-translate-x-2 hover:text-xl hover:text-red-700 ' +
        (disabled ? 'opacity-25' : '')
      }
    >
      <span className="sr-only">Previous</span>
      <IconChevronLeft />
    </button>
  )
}

export const BlogSliderButtonNext = ({ onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      className={
        ' absolute right-0 top-[calc(50%-3rem)]  h-24 w-12 bg-gray-300 bg-opacity-50 duration-300 hover:translate-x-2 hover:text-xl hover:text-red-700 ' +
        (disabled ? 'opacity-25' : '')
      }
    >
      <span className="sr-only">Next</span>
      <IconChevronRight />
    </button>
  )
}

BlogSliderButtonNext.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
BlogSliderButtonPrev.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
